import ProcurementHistoryGrid from './ProcurementHistoryGrid';

export default ProcurementHistoryGrid;



// WEBPACK FOOTER //
// ./src/components/grids/ProcurementHistoryGrid/index.jsx